import React from 'react'
import classes from './PageHeader.module.scss'
import clsx from 'clsx'

const PageHeader = ({
  header,
  usage_text,
  className,
  headerDataTestId = 'header'
}) => {
  return (
    <div className={clsx(classes.pageHeaderContainer, className)}>
      {usage_text && (
        <div className="indicator">
          <span>{usage_text}</span>
        </div>
      )}
      {header && (
        <div className="header" data-testid={headerDataTestId}>
          {header}
        </div>
      )}
    </div>
  )
}

export default PageHeader
